<template>
    <v-stepper-content step="6">
        <v-dialog v-model="objCoberturasModal.abrirModal" persistent max-width="50%" :fullscreen="$root.isTouch">
            <v-card>
                <v-card-title class="bg-title-card">
                    <span class="white--text headline" v-html="objCoberturasModal.titulo"></span>
                </v-card-title>
                <v-form ref="form_coberturas_adicionales_modal">
                    <v-container fluid grid-list-md>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-autocomplete label="Accesorio *" color="textbox"
                                            v-model="objCoberturasModal.idAccesorio"
                                            :items="listGeneral.catalogoAccesorios" item-value="idAccesorio"
                                            item-text="accesorio" :rules="requeridoRegla"
                                            outlined dense />
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-autocomplete label="Estado *" color="textbox"
                                            v-model="objCoberturasModal.idEstado" :items="listGeneral.listaEstados"
                                            item-value="id_estado" item-text="nombre_estado" :rules="requeridoRegla"
                                            outlined dense />
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="text-center" v-if="_.size(objCoberturasModal.idAccesorio) > 0">
                                    <v-img :src="ruta" contain height="200px" max-height="200px" class="mt-2"/>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="text-right">
                                <v-btn outlined rounded color="danger" class="mr-1" @click="salir">Salir</v-btn>
                                <v-btn rounded dark color="primary" @click="validarModal">Guardar</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card>
        </v-dialog>
        <v-container fluid grid-list-md>
            <v-row dense>
                <v-col cols="12" sm="6" />
                <v-col cols="12" sm="6">
                    <v-btn rounded dark color="primary" class="float-right" @click="abrirModal">NUEVO</v-btn>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col xs6 />
                <v-col xs6>
                    <v-text-field label="Buscar" color="textbox" v-model="objCoberturas.busqueda" clearable dense prepend-inner-icon="search"></v-text-field>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col xs12>
                    <v-data-table :search="objCoberturas.busqueda" :headers="listGeneral.cabeceraAccesorios"
                        :items="listGeneral.listaAccesorios" class="elevation-3">
                            <template v-slot:item.accion="{ item }">
                                <v-icon small @click="onEditar(item)">edit</v-icon>
                            </template>

                        <template v-slot:pageText="props">
                            Registro del <span v-text="props.pageStart"></span> al <span v-text="props.pageStop"></span>
                            de <span v-text="props.itemsLength"></span>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="blue" icon="info" style="height:5%">
                                Tu búsqueda de "<span v-text="objCoberturas.busqueda"></span>" no arrojó resultados.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-right">
                    <v-btn outlined rounded color="danger" @click="previous" class="mr-1" :disabled="disabled">Anterior</v-btn>
                    <v-btn rounded dark color="primary" @click="validar" :disabled="disabled">Guardar</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-stepper-content>
</template>

<script>
    export default {
        props: ['cargar', 'objForm', 'listGeneral', 'parametros'],
        inject: ['insertarActualizar', 'previous'],
        data() {
            return {
                disabled: false,
                ruta: '',
                objCoberturas: {},
                objCoberturasModal: {
                    titulo: 'Nuevo Accesorio',
                    abrirModal: false,
                    idEstado: '1'
                },
            }
        },
        watch: {
            cargar() {
                if (this.cargar && _.size(this.listGeneral.listaAccesorios) == 0) {
                    this.objCoberturas = _.clone(this.objForm);

                    var request = [
                        this.onListarCatalogoAccedorios({ opcion: 'CAB_ACCESORIO_PRODUCTO' }, 'cabeceraAccesorios'),
                        this.onListarAccedorios()
                    ];

                    Promise.all(request).catch((e) => {
                        mensajesAlerta(e, 'E');
                    });

                }
            },
            objCoberturasModal:{
                handler(val){
                    var ob = _.find(_.get(this.listGeneral,'listaAccesorios',[]),{'idAccesorio':val.idAccesorio});
                    if(!_.isUndefined(ob)){
                        this.ruta = `data:image/svg+xml;base64,${ob.base64}`
                    }
                },
                deep:true
            }
        },
        methods: {
            onListar(ruta, objeto) {
                return axios.post(`${BASE_URI}${ruta}`, objeto)
                    .then((respuesta) => {
                        if (respuesta.status != 200) throw mensajeEstandar.errorPeticion;
                        if (respuesta.data.existeError) throw respuesta.data.mensaje;
                        if (_.size(respuesta.data.data) == 0)
                            mensajesAlerta(respuesta.data.mensaje, 'I');

                        return respuesta;
                    })
                    .catch((e) =>{
                        return e;
                    })
            },
            onListarCatalogoAccedorios(objeto, lista) {
                return this.onListar('administrador/accesorio/listar', objeto)
                    .then((respuesta) => {
                        if (_.size(_.get(respuesta,['data','data'],[])) > 0)
                            _.set(this.listGeneral, lista, respuesta.data.data);

                        return respuesta;
                    });
            },
            onListarAccedorios() {
                var objeto = { opcion: 'LISTAR', idProducto: this.objCoberturas.idProducto, idEstado: this.objCoberturas.idEstado };

                return this.onListar('administrador/accesorio/listar', objeto)
                    .then((respuesta) => {
                        if (_.size(_.get(respuesta,['data','data'],[])) > 0)
                            _.set(this.listGeneral, 'listaAccesorios', respuesta.data.data);

                        return respuesta;
                    });
            },
            onEditar(objeto) {
                var index = _.findIndex(this.listGeneral.listaAccesorios, (o) => { return parseInt(o.idAccesorio) == parseInt(objeto.idAccesorio) });

                    this.onListarCatalogoAccedorios({ opcion: 'L_COMBO', idEstado: '1' }, 'catalogoAccesorios')
                        .then((respuesta) => {
                            if (_.size(_.get(respuesta,['data','data'],[])) > 0) {
                                var obj = { titulo: 'Editar Cobertura de Accesorio', index: index, abrirModal: true };

                                this.objCoberturasModal = _.merge({}, this.objCoberturasModal, objeto, obj);
                                // this.onObtenerIcono();
                            }
                        }).catch((e) => {
                            mensajesAlerta(mensajeEstandar.errorPeticion, 'E');
                        })
            },
            onObtenerIcono() {
                this.ruta = `${BASE_URI}accesorio/getImage/${this.objCoberturasModal.idAccesorio}`;
            },
            abrirModal() {
                this.onListarCatalogoAccedorios({ opcion: 'L_COMBO', idEstado: '1' }, 'catalogoAccesorios')
                    .then((respuesta) => {
                        if (_.size(_.get(respuesta,['data','data'],[])) > 0){
                            this.objCoberturasModal.abrirModal = true;
                        }
                    }).catch((e) => {
                        mensajesAlerta(mensajeEstandar.errorPeticion, 'E');
                    })
            },
            validar() {
                if (_.size(this.listGeneral.listaAccesorios) > 0){
                    this.disabled = true;
                    this.insertarActualizar()
                        .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw 'Error';
                        })
                        .catch((e) =>{
                            this.disabled = false;
                        });
                }
                else
                    mensajesAlerta(mensajeEstandar.corregirInformacion, 'I');
            },
            // Modal 
            salir() {
                this.ruta = '';
                this.objCoberturasModal = {
                    titulo: 'Nueva Cobertura de Accesorio',
                    abrirModal: false,
                    idEstado: '1'
                };
                this.$refs.form_coberturas_adicionales_modal.resetValidation();
            },
            validarModal() {
                try {
                    if (!this.$refs.form_coberturas_adicionales_modal.validate()) throw mensajeEstandar
                        .corregirInformacion;
                    if (_.isUndefined(this.objCoberturasModal.index)) {
                        if (this._validarInformacion(this.listGeneral.listaAccesorios, null, this.objCoberturasModal
                                .idAccesorio, 'idAccesorio')) throw mensajeEstandar.registroExistente;
                    } else
                    if (this._validarInformacion(this.listGeneral.listaAccesorios, this.objCoberturasModal.index, this
                            .objCoberturasModal.idAccesorio, 'idAccesorio')) throw mensajeEstandar.registroExistente;

                    this.objCoberturasModal.icono = 'SI';
                    var accesorio = _.find(this.listGeneral.catalogoAccesorios, (o) => {
                        if (parseInt(o.idAccesorio) == parseInt(this.objCoberturasModal.idAccesorio)) return o;
                    });
                    this.objCoberturasModal.accesorio = _.size(accesorio) > 0 ? accesorio.accesorio : '';

                    var estado = _.find(this.listGeneral.listaEstados, (o) => {
                        if (parseInt(o.id_estado) == parseInt(this.objCoberturasModal.idEstado)) return o;
                    });
                    this.objCoberturasModal.estado = _.size(estado) > 0 ? estado.nombre_estado : '';

                    if (_.isUndefined(this.objCoberturasModal.index)) {
                        this.listGeneral.listaAccesorios.push(_.omit(this.objCoberturasModal, ['titulo',
                        'abrirModal']));
                    } else
                        this.listGeneral.listaAccesorios[this.objCoberturasModal.index] = _.merge(this.listGeneral
                            .listaAccesorios[this.objCoberturasModal.index], _.omit(this.objCoberturasModal, ['titulo',
                                'abrirModal'
                            ]));

                    this.salir();

                } catch (e) {
                    mensajesAlerta(e, 'I');
                }
            }
        }
    }
</script>